import { useEffect } from 'react';

import { registerReadOnlyPresenter } from '@personal-trainer-app/shared';

import { useToast } from '@/components/ui/Toast';

/**
 * The web's read-only presenter: the one reaction to a request refused
 * because an admin is signed in as the member. Headless — it registers with
 * the shared publisher, which hands it only refusals the admin caused, once
 * per burst, and it raises a warning toast with the server's words.
 *
 * Pages need no wiring. Their own error toasts stand down for the burst (the
 * `ToastProvider` reads `wasReadOnlyRefusedRecently`), so "Could not save…"
 * never sits under this one.
 */
export function ReadOnlyNotice(): null {
  const { warning } = useToast();

  useEffect(() => {
    registerReadOnlyPresenter({ present: (error) => warning(error.message) });
  }, [warning]);

  return null;
}

export default ReadOnlyNotice;
